import React, { useCallback, useEffect, useState } from 'react'
import styles from '../Student/login.module.css'
import { useNavigate } from 'react-router-dom'
import { useFormik } from "formik"
import * as yup from "yup";
import { CircularProgress } from '@mui/material';
import { ArrowIcon, BackArrowIcon, LogoIcon, } from '../../../svg';
import { useDispatch } from 'react-redux';
import { AffiliateforgotPassword } from '../../redux/affiliateLoginSlice';
import { unwrapResult } from '@reduxjs/toolkit';

const AffiliateForgotPassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    // schema -----------
    const schema = yup.object().shape({
        email: yup.string().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Please enter valid email").required("Please enter valid email"),
    })

    const {
        errors, values, handleChange, touched, handleBlur, handleSubmit,
    } = useFormik({
        initialValues: {
            email: "",
        },
        validationSchema: schema,
        onSubmit: (values) => {
            handleLogin(values);
        }
    })

    // const handleLogin = useCallback (async (values) => {
    //   dispatch(login(values));
    // })

    const handleLogin = useCallback(async (values) => {
        console.log('values======', values);

        setLoading(true);
        try {
            const result = await dispatch(AffiliateforgotPassword(values));
            unwrapResult(result);
            navigate('/affiliate/otpVerification', { state: { values } });
            // navigate("")
        } catch (error) {
            console.error('Login failed:', error);
        } finally {
            setLoading(false);
        }
    }, [dispatch, navigate]);

    return (
        <div className={styles.container}>
            <div className={styles.main}>
                <div className={styles.mainContainer}>
                    <LogoIcon />
                </div>
                <div className={styles.login}>
                    <div className={styles.mobileViewLogin}>
                        <div className={styles.mobileLogoStyle}>
                            <h3>KINGSTER</h3>
                        </div>
                    </div>
                    <div className={styles.content} style={{ marginTop: 20 }}>
                        <div onClick={() => navigate('/affiliate/login')} style={{display:"flex",alignItems:"center",cursor:"pointer"}}><BackArrowIcon /> <span className={styles.backToLogin}>Back to Login</span></div>
                        {/* <div onClick={() => navigate('/')} className={styles.backArrow}><BackArrowIcon /><h3>Forgot Password?</h3></div> */}
                        <h3 style={{ marginTop: 50 }} className={styles.forgotPassword}>Forgot Password?</h3>
                        <div style={{ marginTop: 20 }}>
                            <label className={styles.label}>Email</label>
                            <div className={styles.inputbox}>
                                <input
                                    type='email'
                                    onBlur={handleBlur}
                                    value={values.name}
                                    placeholder='Email Address'
                                    name="email"
                                    onChange={handleChange}
                                />
                            </div>
                            {
                                errors.email && touched.email && <p style={{ color: "red", fontSize: "12px", textAlign: "left" }}>{errors.email}</p>
                            }
                        </div>
                        <div className={styles.google}>
                            <div className={styles.saveButtonStyle} onClick={handleSubmit} disabled={loading} style={{ marginTop: 30 }}>
                                {
                                    loading ?
                                        <CircularProgress size={25} thickness={4.5} sx={{ color: "#fff" }} />
                                        : "Submit"
                                } <ArrowIcon />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}



export default AffiliateForgotPassword;
